import styled from 'styled-components'

export const StyledDiv = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
`


// WEBPACK FOOTER //
// ./src/hoc/MiddleCenter/styled.js